import { render, staticRenderFns } from "./CopyContentBtn.vue?vue&type=template&id=70b3866d"
import script from "./CopyContentBtn.vue?vue&type=script&lang=ts"
export * from "./CopyContentBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports